export const ownersByNameWithOnlyBasicDetails = /* GraphQL */ `
  query OwnersByName(
    $name: String!
    $createdOn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOwnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ownersByName(
      name: $name
      createdOn: $createdOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        address {
          city
          provState
        }
        contact {
          personalEmail
        }
        barnId
      }
      nextToken
    }
  }
`;